<script>
	import '../../app.postcss';
	// import mixpanel from 'mixpanel-browser';
	// import { page } from '$app/stores';

	// Replace YOUR_TOKEN with your Project Token
	// mixpanel.init('30f8919ea459d5bc9530fa6428dbd457', { debug: true });

	// let user;
	// user = $page.data.user;
	// let path = $page.url.pathname; for testing search url params
</script>

<main>
	<slot />
</main>
